import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ProcessStateDto, ProcessStateTransitionDto } from '@core/services/api-clients';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '../../../../shared/icon/icon.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'engine-process-current-state',
    templateUrl: './engine-process-current-state.component.html',
    styleUrls: ['./engine-process-current-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatTooltip,
        IconComponent,
        MatButton,
    ]
})
export class EngineProcessCurrentStateComponent {

  private greyColor: string = "#B3B3BF";
  private blueColor: string = "#00A3D7";
  readonly processState = input<ProcessStateDto>(undefined);
  readonly executeProcessTransition = output<{
    currentProcessState: ProcessStateDto;
    targetStateId: string;
}>();
  readonly navigateToRelatedRecord = output<ProcessStateDto>();

  executeTransition(targetStateId: string) {
    this.executeProcessTransition.emit({ currentProcessState: this.processState(), targetStateId: targetStateId });
  }

  getTransitionBackgroundColor(transition: ProcessStateTransitionDto) {
    return transition?.htmlColor ? transition.htmlColor : '#ffffff';
  }

  getStateBorder(processState: ProcessStateTransitionDto, isTransitionButton: boolean = false){
    if (isTransitionButton)
      return `2px solid ${processState?.htmlColor ? processState.htmlColor : this.greyColor}`;
    else
      return `2px solid ${processState?.htmlColor ? processState.htmlColor : this.blueColor}`;
  }

  getStateColor(processState: ProcessStateTransitionDto, isTransitionButton: boolean = false){
    if (isTransitionButton)
      return `${processState?.htmlColor ? processState.htmlColor : this.greyColor}`;
    else
      return `${processState?.htmlColor ? processState.htmlColor : this.blueColor}`;
  }
}
